import { Resource as l } from "@coveo/platform-client";
const i = class i extends l {
  async objects(s) {
    const e = await this.api.get(
      this.buildPath(i.baseUrl, {
        refreshTokenGuid: s,
        serviceCloudIndexed: !0,
        knowledgeIndexed: !0
      })
    );
    return this.objectsAndFieldsSorter(e);
  }
  async objectFields(s, e) {
    const t = await this.api.get(
      this.buildPath(
        `${i.baseUrl}/${encodeURIComponent(e)}/fields`,
        { refreshTokenGuid: s }
      )
    );
    return this.objectsAndFieldsSorter(t);
  }
  async objectRelationship(s, e, t) {
    const o = await this.api.get(
      this.buildPath(
        `${i.baseUrl}/${encodeURIComponent(e)}/${encodeURIComponent(t)}`,
        { refreshTokenGuid: s }
      )
    );
    return {
      ...o,
      fields: this.objectsAndFieldsSorter(o.fields)
    };
  }
  async object(s, e) {
    const t = await this.api.get(
      this.buildPath(
        `${i.baseUrl}/${encodeURIComponent(e)}`,
        { refreshTokenGuid: s }
      )
    );
    return {
      ...t,
      fields: this.objectsAndFieldsSorter(t.fields),
      relationships: this.relationShipSorter(t.relationships)
    };
  }
  objectsAndFieldsSorter(s) {
    return s.slice().sort((e, t) => Number(t.indexed) - Number(e.indexed) || e.label.localeCompare(t.label));
  }
  relationShipSorter(s) {
    return s.slice().sort((e, t) => e.relationshipName.localeCompare(t.relationshipName));
  }
};
i.baseUrl = "/rest/sourceconfiguration/salesforce/objects";
let r = i;
export {
  r as SalesforceSourceConfigurationInternalResource
};
//# sourceMappingURL=SalesforceSourceConfigurationInternalResource.js.map
